"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigate = void 0;
// @ts-ignore
var query_string_1 = require("query-string");
var Navigate = /** @class */ (function () {
    function Navigate() {
    }
    Navigate.navigateTo = function (url) {
        var domain = Navigate.domain();
        try {
            window.location.href = url;
        }
        catch (e) {
            console.error(e);
        }
        if (!Navigate.isUnitTest()) {
            var parsedUrl = new URL(url);
            if (parsedUrl.hostname === domain) {
                Navigate.lastUrl = url;
                if (Navigate.onUpdate !== undefined) {
                    Navigate.onUpdate(Navigate.lastUrl ? Navigate.lastUrl : "");
                }
            }
        }
        else {
            Navigate.lastUrl = url;
            if (Navigate.onUpdate !== undefined) {
                Navigate.onUpdate(Navigate.lastUrl ? Navigate.lastUrl : "");
            }
        }
    };
    Navigate.url = function () {
        if (Navigate.lastUrl) {
            return Navigate.lastUrl;
        }
        else if (typeof window !== 'undefined' && window.location !== undefined) {
            // @ts-ignore
            return window.location.href;
        }
        else if (typeof self !== 'undefined' && self.location) {
            return self.location.href;
        }
        return undefined;
    };
    Navigate.page = function () {
        var url = Navigate.url();
        if (!url)
            return undefined;
        var page = url.substring(url.lastIndexOf('/') + 1);
        page = page.split('?')[0];
        return page;
    };
    Navigate.queryObject = function () {
        var url = this.url();
        if (!url) {
            return {};
        }
        // @ts-ignore
        var parsed = (0, query_string_1.parseUrl)(url);
        if (!parsed || !parsed.query) {
            return {};
        }
        return parsed.query;
    };
    Navigate.clearQueryParams = function () {
        var _a;
        var url = Navigate.url();
        if (!url)
            return;
        // @ts-ignore
        var parsed = (0, query_string_1.parseUrl)(url);
        var baseUrl = (_a = parsed.url) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        if (!baseUrl)
            return;
        // @ts-ignore
        window.history.pushState({}, '', baseUrl);
        Navigate.lastUrl = baseUrl;
        if (Navigate.onUpdate !== undefined) {
            Navigate.onUpdate(Navigate.lastUrl ? Navigate.lastUrl : "");
        }
    };
    Navigate.clearQueryParamsExcept = function () {
        var _a;
        var retain = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            retain[_i] = arguments[_i];
        }
        var url = Navigate.url();
        if (!url)
            return;
        // @ts-ignore
        var parsed = (0, query_string_1.parseUrl)(url);
        var query = parsed.query;
        var filteredQuery = {};
        for (var key in query) {
            if (retain.indexOf(key) !== -1) {
                filteredQuery[key] = query[key];
            }
        }
        var updatedQueryString = (0, query_string_1.stringify)(filteredQuery);
        var baseUrl = (_a = parsed.url) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        if (!baseUrl)
            return;
        var newUrl = updatedQueryString ? "".concat(baseUrl, "?").concat(updatedQueryString) : baseUrl;
        // @ts-ignore
        window.history.pushState({}, '', newUrl);
        Navigate.lastUrl = newUrl;
        if (Navigate.onUpdate !== undefined) {
            Navigate.onUpdate(Navigate.lastUrl ? Navigate.lastUrl : "");
        }
    };
    Navigate.updateQueryParam = function (key, value) {
        var _a;
        var url = Navigate.url();
        if (!url)
            return;
        // @ts-ignore
        var parsed = (0, query_string_1.parseUrl)(url);
        var query = parsed.query;
        if (value === undefined || value === null) {
            delete query[key];
        }
        else {
            query[key] = String(value);
        }
        var updatedQueryString = (0, query_string_1.stringify)(query);
        var baseUrl = (_a = parsed.url) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        if (!baseUrl)
            return;
        var newUrl = "".concat(baseUrl, "?").concat(updatedQueryString);
        // @ts-ignore
        window.history.pushState({}, '', newUrl);
        Navigate.lastUrl = newUrl;
        if (Navigate.onUpdate !== undefined) {
            Navigate.onUpdate(Navigate.lastUrl ? Navigate.lastUrl : "");
        }
    };
    Navigate.domain = function () {
        var url = Navigate.url();
        if (!url)
            return undefined;
        try {
            // @ts-ignore
            var parsedUrl = new URL(url);
            return parsedUrl.hostname;
        }
        catch (e) {
            return undefined;
        }
    };
    Navigate.isUnitTest = function () {
        // @ts-ignore
        return typeof window !== 'undefined' && window.isUnitTest === true;
    };
    return Navigate;
}());
exports.Navigate = Navigate;
